if (!customElements.get("pickup-availability")) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute("available")) return;

      this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.baseUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      
      // Agregar el keyword de tienda preferida como parámetro
      let variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
      const preferredKeyword = this.dataset.preferredStoreKeyword;
      if (preferredKeyword) {
        variantSectionUrl += `&preferred_store_keyword=${encodeURIComponent(preferredKeyword)}`;
        console.log('🏪 Pickup Availability - Preferred Store Keyword:', preferredKeyword);
        console.log('🔗 Fetch URL:', variantSectionUrl);
      }

      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
          this.renderPreview(sectionInnerHTML);
        })
        .catch((e) => {
          const button = this.querySelector("button");
          if (button) button.removeEventListener("click", this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      if (variant?.available) {
        this.fetchAvailability(variant.id);
      } else {
        this.removeAttribute('available');
        this.innerHTML = "";
      }
    }

    renderError() {
      this.innerHTML = "";
      this.appendChild(this.errorHtml);

      this.querySelector("button").addEventListener("click", this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector("#Drawer-Pickup-Availability");
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
        this.innerHTML = "";
        this.removeAttribute("available");
        return;
      }

      // Aplicar priorización de tienda preferida antes de renderizar
      this.applyStorePreference(sectionInnerHTML);

      this.innerHTML = sectionInnerHTML.querySelector("pickup-availability-preview").outerHTML;
      this.setAttribute("available", "");

      document.body.appendChild(sectionInnerHTML.querySelector("#Drawer-Pickup-Availability"));

      const button = this.querySelector("button");

      if (button) {
        button.addEventListener("click", (e) => {
          document.querySelector("#Drawer-Pickup-Availability").openDrawer();
        });
      }
    }

    applyStorePreference(sectionInnerHTML) {
      const preferredKeyword = this.dataset.preferredStoreKeyword;
      if (!preferredKeyword) return;

      const keyword = preferredKeyword.toLowerCase().trim();
      console.log('🔍 Buscando tienda con keyword:', keyword);

      // Buscar en los items del drawer
      const storeItems = sectionInnerHTML.querySelectorAll(".m-pickup-availability__item");
      let preferredStore = null;
      let preferredIndex = -1;

      storeItems.forEach((item, index) => {
        const storeName = item.querySelector("h4")?.textContent || "";
        const storeNameLower = storeName.toLowerCase();
        console.log(`  - Tienda ${index + 1}: "${storeName}"`);
        
        if (storeNameLower.includes(keyword) && !preferredStore) {
          preferredStore = item;
          preferredIndex = index;
          console.log(`  ✅ Encontrada en índice ${index}!`);
        }
      });

      if (preferredStore && preferredIndex > 0) {
        console.log(`🔄 Reordenando: moviendo "${preferredStore.querySelector("h4").textContent}" al inicio`);
        
        // Obtener el contenedor de la lista
        const listContainer = sectionInnerHTML.querySelector(".m-pickup-availability__items");
        
        // Mover la tienda preferida al inicio
        listContainer.insertBefore(preferredStore, listContainer.firstChild);

        // Actualizar el preview con la información de la tienda preferida
        const preview = sectionInnerHTML.querySelector("pickup-availability-preview");
        const preferredStoreName = preferredStore.querySelector("h4").textContent.trim();
        const preferredAvailability = preferredStore.querySelector(".m-pickup-availability__item--time")?.textContent?.trim() || "";
        
        console.log('📝 Actualizando preview con:', preferredStoreName);
        
        // Actualizar el texto del preview
        const infoDiv = preview.querySelector(".m-pickup-availability__info");
        if (infoDiv) {
          // Buscar todos los elementos que pueden contener el nombre de tienda (p, span, div, etc)
          const allTextElements = infoDiv.querySelectorAll("p, span, div");
          
          // Primero, buscar el nombre actual de la tienda en el preview
          let currentStoreName = null;
          storeItems.forEach(item => {
            const storeName = item.querySelector("h4")?.textContent?.trim() || "";
            if (storeName && infoDiv.textContent.includes(storeName)) {
              currentStoreName = storeName;
            }
          });
          
          console.log(`  - Tienda actual en preview: "${currentStoreName}"`);
          console.log(`  - Reemplazando por: "${preferredStoreName}"`);
          
          // Reemplazar en todos los elementos de texto
          allTextElements.forEach(element => {
            const originalHTML = element.innerHTML;
            let updatedHTML = originalHTML;
            
            // Reemplazar cualquier nombre de tienda anterior con el preferido
            storeItems.forEach(item => {
              const storeName = item.querySelector("h4")?.textContent?.trim() || "";
              if (storeName && updatedHTML.includes(storeName)) {
                updatedHTML = updatedHTML.replace(new RegExp(storeName, 'g'), preferredStoreName);
                console.log(`    ✓ Reemplazado "${storeName}" en <${element.tagName.toLowerCase()}>`);
              }
            });
            
            if (originalHTML !== updatedHTML) {
              element.innerHTML = updatedHTML;
            }
          });
          
          // Actualizar el tiempo de pickup si existe
          const timeText = infoDiv.querySelector("p.m\\:text-color-subtext") || infoDiv.querySelector("p:last-child");
          if (timeText && preferredAvailability) {
            // Extraer solo el texto de disponibilidad (ej: "normalmente está listo en 4 horas")
            const availabilityMatch = preferredAvailability.match(/normalmente está listo en [^,]+/i);
            if (availabilityMatch) {
              timeText.textContent = availabilityMatch[0];
              console.log('    ✓ Tiempo actualizado:', availabilityMatch[0]);
            }
          }
        }
        
        console.log('✅ Preview actualizado con tienda preferida');
      } else if (preferredIndex === 0) {
        console.log('ℹ️ La tienda preferida ya está primera');
      } else {
        console.log('⚠️ No se encontró tienda con keyword:', keyword);
      }
    }
  }

  customElements.define("pickup-availability", PickupAvailability);
}

if (!customElements.get("pickup-availability-drawer")) {
  class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.drawerWapper = this.querySelector(".m-drawer__wrapper");
      this.drawerContent = this.querySelector(".m-drawer__content");
      this.drawerClose = this.querySelector(".m-drawer__close");

      this.drawerClose.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeDrawer();
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.classList.contains("m-drawer__wrapper")) this.closeDrawer();
      });
    }

    openDrawer() {
      if (window.innerWidth < 770) {
        document.documentElement.classList.add("prevent-scroll");
        this.drawerWapper.classList.add("mobile");
      }
      this.drawerWapper.classList.remove("m:hidden");
      requestAnimationFrame(() => {
        this.drawerWapper.style.setProperty("--m-bg-opacity", "0.5");
        this.drawerContent.style.setProperty("--m-translate-x", "0");
        // this.drawerContent.classList.remove('translate-x-full')
      });
    }

    closeDrawer() {
      this.drawerWapper.style.setProperty("--m-bg-opacity", "0");
      this.drawerContent.style.setProperty("--m-translate-x", "100%");
      // this.drawerContent?.classList.add('translate-x-full')
      setTimeout(() => {
        this.drawerWapper.classList.add("m:hidden");
        this.drawerWapper.classList.remove("mobile");
        document.documentElement.classList.remove("prevent-scroll");
      }, 300);
    }
  }

  customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);
}
